export const ACTION_SITESETTINGS_ADD = 'ACTION_SITESETTINGS_ADD'
export const ACTION_SITESETTINGS_LIST = 'ACTION_SITESETTINGS_LIST'
export const ACTION_SITESETTINGS_LIST_FAIL = 'ACTION_SITESETTINGS_LIST_FAIL'
export const ACTION_SITESETTINGS_GET = 'ACTION_SITESETTINGS_GET'
export const ACTION_SITESETTINGS_GET_FAIL = 'ACTION_SITESETTINGS_GET_FAIL'